'use strict';

angular.module('shiftTraderApp')
  .controller('CreateDayOffLimitExceptionModalCtrl', function($scope, $uibModalInstance, SAErrorHandler, params, toastr,
                                                              Session, TimeService, DayOffLimitStore, DayOffLimits, $confirm, $filter) {

    var vm = this;


    vm.me = params.me;
    vm.user = params.user;
    vm.startOfWeekDay = Session.getStartOfWeekDay();
    vm.workDayStartHour = Session.getWorkDayStartHour();
    vm.beginningOfToday = TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime());
    vm.dateToday = moment(vm.beginningOfToday).add(1, 'day').toDate();
    //vm.dateToday = new Date();

    vm.dayOffLimitRecord = params.dayOffLimitRecord;

    var dayNumberToWords = $filter('dayNumberToWords');

    vm.formData = {
      exceptionDate: null,
      limit: 5,
      note: ''
    };

    function setExceptionDate(dt) {
      vm.formData.exceptionDate = moment(dt).tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).toDate();
    }


    vm.datePickerOptions = {
      startingDay: vm.startOfWeekDay,
      showWeeks: false
    };

    vm.state = {
      isInEditMode: !!params.dayOffLimitRecord,
      exceptionDateOpened: false,
      requestInProgress: false,
      buttonText: 'Create Exception',
      validations: {

      }
    };

    if (vm.state.isInEditMode) {
      setExceptionDate(vm.dayOffLimitRecord.target_date);
      vm.formData.limit = vm.dayOffLimitRecord.limit;

      if (vm.dayOffLimitRecord.$getLatestMessage()) {
        vm.formData.note = vm.dayOffLimitRecord.$getLatestMessage().text;
      }
    } else {
      setExceptionDate(moment.utc().add(2, 'weeks'));
    }

    function setReviewText() {
      if (vm.state.limitRecordForCurrentDate) {
        if (vm.state.limitRecordForCurrentDate.$isException()) {
          return 'Creating this exception would override the current limit of ' + vm.state.limitRecordForCurrentDate.limit + ' set by a prior day off limit exception.'
        } else {
          return 'Creating this exception would override the current ' + dayNumberToWords(vm.state.limitRecordForCurrentDate.day_of_week) + ' general day off limit of ' + vm.state.limitRecordForCurrentDate.limit + '.';
        }
      } else {
        return 'Creating this exception will set a limit of ' + vm.formData.limit + ' for ' + getMomentForException().format('MMM D, YYYY');
      }

    }

    function getLimitForSelectedDate() {
      DayOffLimitStore.getLimitForDate(getMomentForException())
        .then(function(val) {
          vm.state.limitRecordForCurrentDate = val;
          vm.state.reviewText = setReviewText();
        }, function() {

        });
    }

    getLimitForSelectedDate();

    if (vm.state.isInEditMode) {
      $scope.$watch('vm.formData.limit', function(newLimit) {
        if (newLimit !== vm.dayOffLimitRecord.limit) {
          vm.state.buttonText = 'Change Limit and Note';
        } else {
          vm.state.buttonText = 'Change Note';
        }
      });
    }

    $scope.$watch('vm.formData.exceptionDate', function(newValue, oldValue) {
      if (newValue !== oldValue) {
        getLimitForSelectedDate();
      }
    });

    vm.openDatepicker = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if (vm.state.exceptionDateOpened === true) {
        vm.state.exceptionDateOpened = false;
      } else {
        vm.state.exceptionDateOpened = true;
      }
    };

    vm.decrementLimit = function() {
      if (vm.formData.limit === '' || _.isNaN(vm.formData.limit) || _.isUndefined(vm.formData.limit) || _.isNull(vm.formData.limit)) {
        vm.formData.limit = 0;
      }

      if (vm.formData.limit > 0) {
        vm.formData.limit = vm.formData.limit - 1;
      }
    };

    vm.incrementLimit = function() {
      if (vm.formData.limit === '' || _.isNaN(vm.formData.limit) || _.isUndefined(vm.formData.limit) || _.isNull(vm.formData.limit)) {
        vm.formData.limit = 0;
      }

      vm.formData.limit = vm.formData.limit + 1;
    };

    function getMomentForException() {
      return TimeService.getBeginningOfDayFromDate(moment(vm.formData.exceptionDate));
    }

    vm.isExceptionValid = function() {
      // check if the date is in the past
      // check if the limit is >= 0
      // make sure there is a short message

      vm.state.validations.exceptionDateAfterToday = vm.beginningOfToday.isBefore(getMomentForException());

      vm.state.validations.limitPositive = vm.formData.limit >= 0;

      vm.state.validations.messageLengthPositive = vm.formData.note.length > 0;

      return vm.state.validations.exceptionDateAfterToday && vm.state.validations.limitPositive;
    };


    vm.createOrConfirm = function() {
      var updateMessageOnly = false;

      if (vm.state.isInEditMode && vm.dayOffLimitRecord.limit === vm.formData.limit) {
        updateMessageOnly = true;
      }

      if (vm.state.validations.messageLengthPositive) {
        if (updateMessageOnly) {
          vm.dayOffLimitRecord.$addMessage(vm.formData.note)
            .then(function() {
              $uibModalInstance.close();
            })
        } else {
          vm.createException().
            then(function() {
              $uibModalInstance.close();
            });
        }
      } else {
        $confirm({
          text: 'Are you sure you don\'t want to write a note to your staff?',
          ok: 'Yes',
          cancel: 'No, I\'ll go back.'
        })
          .then(function() {
            vm.createException().
              then(function() {
                $uibModalInstance.close();
              });
          }, function() {
            // do nothing
          })
      }
    };

    vm.createException = function() {

      var orgId = vm.me.memberships[0].organization ? vm.me.memberships[0].organization.id : vm.me.memberships[0].organization_id;

      var dt = getMomentForException();

      var data = {
        organization_id: orgId,
        target_date: dt.format('YYYY-MM-DD'),
        day_of_week: dt.day(),
        limit: vm.formData.limit
      };

      if (vm.formData.note.length > 0) {
        data.message = vm.formData.note;
      }

      return DayOffLimits.create(data)
        .then(function(newLimit) {
          if (vm.state.limitRecordForCurrentDate && vm.state.limitRecordForCurrentDate.$isException() && vm.state.limitRecordForCurrentDate.target_date.isSame(newLimit.target_date)) {
            DayOffLimitStore.removeRecordById(vm.state.limitRecordForCurrentDate.id);
          }

          DayOffLimitStore.addOrReplaceRecord(newLimit);
          toastr.success('A limit of ' + newLimit.limit + ' has been added to ' + dt.format('M-D-YYYY'), 'Success');
          setExceptionDate(moment(newLimit.target_date).add(1, 'days'));
        }, function(response) {
          console.log(response);
          SAErrorHandler.processError(response);

        });
    };

    vm.close = function() {
      $uibModalInstance.close();
    };
  });
